import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getConflictTasksInProject } from "~/store/selectors/selector.taskDependencies";
import { getTaskById } from "~/store/selectors/selector.tasks";

export const useTimeLineNavigation = (taskId) => {
  const task = useSelector((state) => getTaskById(state, taskId));
  const tasks = useSelector((state) => getConflictTasksInProject(state, task?.project_id));

  const sorted = useMemo(() => {
    if (tasks) {
      return tasks.reduce((prev, next) => {
        if (next.class === "Task" && !next.is_completed) {
          prev.push(next);
        }
        return prev;
      }, []);
    }
    return [];
  }, [tasks]);

  const index = task ? sorted.findIndex((t) => t.id === task.id) : -1;
  const prev = index > -1 && sorted[index - 1] ? sorted[index - 1]?.id : null;
  const next = index > -1 && sorted[index + 1] ? sorted[index + 1]?.id : null;

  return [prev, next];
};
